export var isAnchorEvent = function isAnchorEvent(event) {
  return !!event.target.getAttribute('href');
};
export var isButtonEvent = function isButtonEvent(event) {
  return !!event.target.getAttribute('type');
};